import {
    addToChainBefore,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { AddCartLinesApiParameter, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    DispatchBeginPlaceOrder,
    chain,
} from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { setShowRequisitionCartDisclaimer } from "@tKgpco/Handlers/RequistionCart/Handlers/showRequisitionCartDisclaimer";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

type HandlerType = ApiHandlerDiscreteParameter<
    { order?: CartModel } & HasOnSuccess & HasOnError<string>,
    AddCartLinesApiParameter,
    CartModel,
    { updateCartApiParameter: UpdateCartApiParameter }
>;

export const DispatchBeginPlaceOrderCustom: HandlerType = props => {
    const state = props.getState() as CustomApplicationState;

    if (state.KGPState.RequistionCartStore.isRequistionCartPresent) {
        props.dispatch(setShowRequisitionCartDisclaimer({ showDisclaimerForRequistionCart: true }));
        return false;
    }
};

addToChainBefore(chain, DispatchBeginPlaceOrder, DispatchBeginPlaceOrderCustom);
